import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { cloneDeep } from "lodash";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../../records/server/query";
import {
  RecordsUtilsService,
  vsName as RecordsUtilsServiceName,
} from "../../../../../records/utils";
import {
  ProgressiveDefinition,
  ProgressiveDefinitionGame,
} from "../../../models/progressiveDefinition";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../app/records/server/serverUtility";
import { $confirm } from "../../../../../../@custom_types/confirm";
const machineConfigurationGridId = Symbol(
  "main.machines.progressives.detail.progressiveMachines"
);

export class ProgressivesDetailComponentController implements IOnInit {
  static $inject = [
    GridSettingsServiceName,
    RecordsUtilsServiceName,
    "$state",
    "$confirm",
    ServerUtilityName,
  ];

  readonly defaultQuery: IQuery = {};
  readonly gridSettings: IGridSettings;

  /* bindings */
  private readonly progressiveDefinition!: ProgressiveDefinition;
  /* end bindings */

  constructor(
    gridSettingsService: GridSettingsService,
    private readonly recordUtils: RecordsUtilsService,
    private readonly $state: StateService,
    private readonly $confirm: $confirm,
    private readonly serverUtility: ServerUtility
  ) {
    this.gridSettings = gridSettingsService.getGridSettings(
      machineConfigurationGridId
    );
  }

  clone() {
    const newProgressive = cloneDeep(this.progressiveDefinition);
    this.recordUtils.stripIds(newProgressive);
    this.$state.go("main.machines.progressives.add", {
      progressiveDefinition: newProgressive,
    });
  }

  delete() {
    const progressiveDefinitionId = this.progressiveDefinition.Id;
    this.$confirm({
      text: "Are you sure you want to delete this entry?",
    })
      .then(() => {
        return this.serverUtility.sendApiRequest({
          method: "delete",
          url: `api/machines/progressives/ProgressiveDefinition/${progressiveDefinitionId}`,
        });
      })
      .then(() => {
        this.$state.go("main.machines.progressives");
      })
      .catch((reason: any) => {
        if (reason === "cancel") {
          // Handle cancellation
          console.log("Deletion canceled");
        } else {
          // Handle other errors
          console.error("Error during deletion:", reason);
        }
      });
  }

  $onInit(): void {}

  currentConfigurationChanged(currentConfigurationsOnly: boolean) {
    if (!currentConfigurationsOnly) {
      this.defaultQuery.CurrentConfiguration = undefined;
    }
  }

  getGameHeader(game: ProgressiveDefinitionGame): string {
    return `${game.GameProgramNumber} - ${game.PaytableId}`;
  }
}
